let eventSet = false;
document.addEventListener('click', () => {
  const radios = document.getElementsByClassName('hs-input');
  if (radios && !eventSet) {
    radios.forEach(radio => {
      radio.addEventListener('click', () => {
        if (radio.checked && radio.type === 'radio') {
          // check if any radios have the checked style applied, remove if so
          const activeRadios = document.getElementsByClassName('hs-input-radio-display-check');
          if (activeRadios) {
            activeRadios.forEach(activeRadio => {
              activeRadio.classList.remove('hs-input-radio-display-check');
            });
          }
          radio.parentElement.classList.add('hs-input-radio-display-check');
        }
      });
    });
    eventSet = true;
  }
});
